const defaultShareIcon =
  'https://dealer2.autoimg.cn/dealerdfs/g30/M08/A6/3A/autohomedealer__ChwFlF9a3ySACythAABlUXLCQkM946.jpg';
const defaultAdvisorIcon =
  'https://x.autoimg.cn/dealer/vr/Resources/img/share-miniprogram-head.png';
const pvTrackData = {
  site: 1211004,
  category: 897,
  subcategory: 18491,
};

export const errorPage =
  'https://dealercloud.m.autohome.com.cn/vr4s/index?pvareaid=2594229';

const shareData = {
  title: '汽车之家-智能展厅',
  desc: '全新技术打造，360°无死角浏览，给你不一样的视觉体验！',
  icon: defaultShareIcon,
  link: window.location.origin + window.location.pathname,
  defaultAdvisorIcon,
};
let config = { shareData: shareData, ...WEB_CONFIG, pvTrackData };
if (process.env.NODE_ENV === 'development') {
  config.baseDomain = window.origin;
  config.baseUrl = config.baseDomain + '/vr/';
}

export default config;
